"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTER_IMAGES = exports.FILTERS = void 0;
var FILTERS;
(function (FILTERS) {
    FILTERS["NOIR"] = "noir";
    FILTERS["SILVER"] = "silver";
    FILTERS["MONO"] = "mono";
    FILTERS["DRAMATIC"] = "dramatic";
    FILTERS["VIVID"] = "vivid";
    FILTERS["WINTER"] = "winter";
    FILTERS["PENCIL"] = "pencil";
    FILTERS["PENCIL_NO_BG"] = "pencil-no-bg";
    FILTERS["COLOR_PENCIL"] = "color-pencil";
    FILTERS["COLOR_PENCIL_NO_BG"] = "color-pencil-no-bg";
    FILTERS["DIGITAL_OIL"] = "digital-oil";
    FILTERS["DIGITAL_OIL_NO_BG"] = "digital-oil-no-bg";
    FILTERS["NONE"] = "none";
})(FILTERS = exports.FILTERS || (exports.FILTERS = {}));
exports.FILTER_IMAGES = {
    [FILTERS.NOIR]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/noir.png',
    },
    [FILTERS.SILVER]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/silver.png',
    },
    [FILTERS.MONO]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/mono.png',
    },
    [FILTERS.DRAMATIC]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/dramatic.png',
    },
    [FILTERS.VIVID]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/vivid.png',
    },
    [FILTERS.WINTER]: {
        png: 'https://res.cloudinary.com/mixtiles/image/upload/filterImages/winter.png',
    },
};
//# sourceMappingURL=filters.js.map